module.exports = __webpack_public_path__ + "static/media/guanyinshan2.d1ffbe20.webp";